import styled from 'styled-components'

interface IAPUnbilledItemTagProps {}

export const APUnbilledItemTagStyled = styled.div<IAPUnbilledItemTagProps>``
